import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "spinner"
}
const _hoisted_6 = {
  class: "modal fade",
  tabindex: "-1",
  role: "dialog",
  id: "qr_modal"
}
const _hoisted_7 = {
  class: "modal-dialog modal-dialog-centered modal-fullscreen-sm-down",
  role: "document"
}
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = {
  key: 0,
  class: "modal-body text-center"
}
const _hoisted_10 = { class: "d-flex justify-content-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "row mb-3 px-2 text-start" }
const _hoisted_13 = {
  key: 0,
  type: "hidden",
  name: "qr_type",
  value: "normal"
}
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.node && _ctx.node.share)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            href: "#",
            class: "me-2",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.copyClipboard(_ctx.node.share.show)), ["prevent"]))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fas fa-clipboard fa-2x" }, null, -1)
          ])),
          _createElementVNode("a", {
            href: _ctx.node.share.line,
            target: "_blank"
          }, _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fab fa-line fa-2x ms-3" }, null, -1)
          ]), 8, _hoisted_2),
          _createElementVNode("a", {
            href: _ctx.node.share.twitter,
            target: "_blank"
          }, _cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fab fa-x-twitter fa-2x ms-3" }, null, -1)
          ]), 8, _hoisted_3),
          _createElementVNode("a", {
            href: _ctx.node.share.facebook,
            target: "_blank"
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("i", { class: "fab fa-facebook fa-2x ms-3" }, null, -1)
          ]), 8, _hoisted_4),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showQrModal && _ctx.showQrModal(...args)), ["prevent"]))
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "fas fa-qrcode fa-2x ms-3" }, null, -1)
          ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "bounce1" }, null, -1),
          _createElementVNode("div", { class: "bounce2" }, null, -1),
          _createElementVNode("div", { class: "bounce3" }, null, -1)
        ]))),
    _cache[19] || (_cache[19] = _createElementVNode("div", {
      id: "clipboard",
      "aria-hidden": "true"
    }, null, -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "QRコードのダウンロード"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-mdb-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (_ctx.node && _ctx.node.share)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: _ctx.qr_url,
                    class: "w-75"
                  }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "col-3 pt-2" }, "色", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "qr_color form-control col-9",
                    name: "qr_color",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.qr_color) = $event))
                  }, _cache[11] || (_cache[11] = [
                    _createStaticVNode("<option value=\"184,28,34\" data-v-13b03560>赤</option><option value=\"96,59,148\" data-v-13b03560>紫</option><option value=\"52,120,56\" data-v-13b03560>緑</option><option value=\"0,0,0\" data-v-13b03560>黒</option><option value=\"72,97,151\" data-v-13b03560>青</option><option value=\"255,69,0\" data-v-13b03560>オレンジ</option>", 6)
                  ]), 512), [
                    [_vModelSelect, _ctx.qr_color]
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("label", { class: "col-3 pt-2" }, "大きさ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "size form-control col-9",
                    name: "size",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.size) = $event))
                  }, _cache[12] || (_cache[12] = [
                    _createStaticVNode("<option value=\"\" disabled data-v-13b03560>画面用</option><option value=\"px:450\" data-v-13b03560>標準：450ピクセル</option><option value=\"px:305\" data-v-13b03560>小：200ピクセル</option><option value=\"\" disabled data-v-13b03560>印刷用 350dpi</option><option value=\"dpi:350,mm:15\" data-v-13b03560>15mm：207ピクセル</option><option value=\"dpi:350,mm:20\" data-v-13b03560>20mm：276ピクセル</option><option value=\"dpi:350,mm:25\" data-v-13b03560>25mm：344ピクセル</option><option value=\"dpi:350,mm:30\" data-v-13b03560>30mm：413ピクセル</option><option value=\"dpi:350,mm:35\" data-v-13b03560>35mm：482ピクセル</option><option value=\"dpi:350,mm:40\" data-v-13b03560>40mm：551ピクセル</option><option value=\"dpi:350,mm:45\" data-v-13b03560>45mm：620ピクセル</option><option value=\"dpi:350,mm:50\" data-v-13b03560>50mm：689ピクセル</option><option value=\"\" disabled data-v-13b03560>印刷用 600dpi</option><option value=\"dpi:600,mm:15\" data-v-13b03560>15mm：354ピクセル</option><option value=\"dpi:600,mm:20\" data-v-13b03560>20mm：472ピクセル</option><option value=\"dpi:600,mm:25\" data-v-13b03560>25mm：591ピクセル</option><option value=\"dpi:600,mm:30\" data-v-13b03560>30mm：709ピクセル</option><option value=\"dpi:600,mm:35\" data-v-13b03560>35mm：827ピクセル</option><option value=\"dpi:600,mm:40\" data-v-13b03560>40mm：945ピクセル</option><option value=\"dpi:600,mm:45\" data-v-13b03560>45mm：1063ピクセル</option><option value=\"dpi:600,mm:50\" data-v-13b03560>50mm：1181ピクセル</option><option value=\"\" disabled data-v-13b03560>デザインソフト用</option><option value=\"dpi:600,mm:20,svg:1\" data-v-13b03560>SVG</option>", 23)
                  ]), 512), [
                    [_vModelSelect, _ctx.size]
                  ]),
                  (_ctx.node.node_type == 10)
                    ? (_openBlock(), _createElementBlock("input", _hoisted_13))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "col-3 pt-2" }, "種類", -1)),
                        _withDirectives(_createElementVNode("select", {
                          class: "size form-control col-9",
                          name: "qr_type",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.qr_type) = $event))
                        }, _cache[13] || (_cache[13] = [
                          _createElementVNode("option", { value: "normal" }, "QRコード", -1),
                          _createElementVNode("option", { value: "memory" }, "記録用QRコード", -1)
                        ]), 512), [
                          [_vModelSelect, _ctx.qr_type]
                        ])
                      ], 64))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              class: "btn btn-primary me-2",
              href: _ctx.qr_download_url
            }, "ダウンロード", 8, _hoisted_15),
            _cache[17] || (_cache[17] = _createElementVNode("a", {
              href: "#",
              class: "btn btn-default",
              "data-mdb-dismiss": "modal"
            }, "閉じる", -1))
          ])
        ])
      ])
    ])
  ], 64))
}